"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var commitThemeChange_1 = require("./orchestration/commitThemeChange");
var discardThemeChange_1 = require("./orchestration/discardThemeChange");
var ThemeFull_1 = require("./view/ThemeFull");
var ThemeQuick_1 = require("./view/ThemeQuick");
var isThemePreviewDirty_1 = require("./utils/isThemePreviewDirty");
var React = require("react");
var ThemeOption = {
    key: 'theme',
    titleStringKey: 'optionTitle_Theme',
    searchTermsStringKey: 'optionSearch_Theme',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ThemeFull_1.default, null); },
        isDirty: isThemePreviewDirty_1.default,
        onSave: commitThemeChange_1.default,
        onDiscard: discardThemeChange_1.default,
    },
    quickOptionSettings: {
        rendering: {
            render: function () { return React.createElement(ThemeQuick_1.default, null); },
        },
        order: 0 /* Theme */,
        workloads: 2415919103 /* All */,
    },
};
exports.default = ThemeOption;
//# sourceMappingURL=ThemeOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-theme-option/lib/ThemeOption.js
// module id = 4956
// module chunks = 2